







































































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getUniqueId,
    getIndexFromList
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    Input,
    CloseConfirmationModal,
    MultipleSelect
} from '../../core/components';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import { colorReferencesForVariables } from '../utils';
import { VariableStatusChoices } from '../models';

@Component({
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
        DatePickerSingle,
        Input,
        MultipleSelect,
        InfoIcon
    }
})
export default class ModalVehicleSettings extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() patchData: object | null;
    @Prop() visible: boolean;
    @Prop() vehicleID: number;
    @Prop() action: string;
    @Prop({ default: false }) isSowing: boolean | null;
    @Prop({ default: false }) saveOnMemory: boolean;
    @Prop() variablesOptions: Array<object>;
    variableSelected: any = null;
    blacklistedVariableSelected: any = null;
    varRV: boolean = false;
    blacklistedRV: boolean = false;
    workWidthValue: any = null;
    // delayValue: any = '';
    modalTitle: string = 'Modificar Configuración de ';
    dateSelected: any = null;
    hasRTK: boolean = false;
    encased: boolean = false;
    errorMsg: string = '';
    placeholderBlacklistedVariable: string = 'Seleccionar';
    preselectedBlacklistedVars:Array<object> = [];
    colorReferencesForVariables: string = colorReferencesForVariables();
    
    getLabelForMultipleSelect({variable_id, description}){
        return `${variable_id} - ${description}`
    }

    filtersSelectBlacklistedVar(itemToAdd) {
        this.preselectedBlacklistedVars.push(itemToAdd);
    }

    filtersRemoveBlacklistedVar(itemToRemove) {
        this.preselectedBlacklistedVars = this.preselectedBlacklistedVars.filter(
            item => item['variable_id'] !== itemToRemove.variable_id
        );
    }

    get isEncased() {
        if (this.encased) {
            this.updateVariableSelected(null);
            this.preselectedBlacklistedVars = [];
        }
        return this.encased;
    }

    get getLabelEncased() {
        if (!this.isEncased) {
            return 'Con variable de trabajo';
        } else {
            return 'Sin variable de trabajo';
        }
    }

    loadBlacklistedVars(blacklistedVarList){
        if(blacklistedVarList && blacklistedVarList.length > 0){
            for (let index = 0; index < blacklistedVarList.length; index++) {
                const blacklistedVarId = blacklistedVarList[index]['variable_id'];
                let indexInVarOptions = getIndexFromList(this.variablesOptions, 'variable_id', blacklistedVarId);
                if(indexInVarOptions !== -1){
                    this.filtersSelectBlacklistedVar(this.variablesOptions[indexInVarOptions]);
                }
            }
        }
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    saveSetting() {
        let data = this.getData;
        // console.log("save config", this.getData);
        if (!this.isPatch) {
            if (!this.saveOnMemory) {
                //trigger post
                this.postSetting(data);
            } else {
                //export data without triggering post
                if (this.variableSelected && this.variableSelected['id']) {
                    data['work_variable'] = this.variableSelected;
                }
                this.addNewSetting(data);
                this.closeModal();
            }
        } else {
            if (!this.saveOnMemory) {
                //trigger patch
                this.updateSetting(data);
            } else {
                //export data without triggering patch
                if (this.variableSelected && this.variableSelected['id']) {
                    data['work_variable'] = this.variableSelected;
                }
                this.patchSetting(data);
                this.closeModal();
            }
        }
    }

    postSetting(data) {
        this.showLoadingDialog('Guardando Configuración...');

        InsuranceServices.postVehicleSetting(data)
            .then(res => {
                this.showSuccessLoadingDialog(res, 'Configuración creada con éxito');
                this.addNewSetting(res['new_config']);
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo crear la configuración');
            });
    }

    updateSetting(data) {
        this.showLoadingDialog('Modificando Configuración...');
        let self = this;
        if (this.patchData) {
            let settingId = this.patchData['id'];
            InsuranceServices.patchVehicleSetting(data, settingId)
                .then(response => {
                    self.patchSetting(response['data']['updated_config']);
                    self.showSuccessLoadingDialog(response.data, 'Configuración modificada con éxito');
                })
                .catch(err => {
                    self.showCatchLoadingDialog(err, 'No se pudo modificar la configuración');
                });
        }
    }

    get getData() {
        return {
            configuration_date:
                this.dateSelected.indexOf('T') > -1
                    ? this.dateSelected
                    : moment(this.dateSelected, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss'),
            id: this.isPatch && this.patchData !== null ? this.patchData['id'] : getUniqueId(),
            has_rtk: this.hasRTK,
            work_width: Number(this.workWidthValue),
            work_variable: this.variableSelected !== null ? this.variableSelected['id'] : null,
            vehicle_id: this.vehicleID,
            encased: this.encased,
            blacklisted_variables: this.getBlacklistedVariables()
        }
    }

    getBlacklistedVariables(){
        let blacklistedVariablesIds = this.preselectedBlacklistedVars.length > 0 ?  this.preselectedBlacklistedVars.map(s => s['id']) : []
        if(!this.saveOnMemory){
            //ids para enviar a backend si NO es simulador
            return blacklistedVariablesIds
        }else{
            //simulador
            return this.preselectedBlacklistedVars
        }
    }

    updateVariableSelected(value) {
        this.variableSelected = value;
    }
    updateVarRV(value) {
        this.varRV = value;
    }
    updateBlacklistedVariableSelected(value) {
        this.blacklistedVariableSelected = value;
    }
    updateBlacklistedVarRV(value) {
        this.blacklistedRV = value;
    }
    updateWorkWidthValue(value) {
        if (value === '') {
            value = null;
        }
        this.workWidthValue = value;
    }
    // updateDelayValue(value) {
    //     if (value === '') {
    //         value = null;
    //     }
    //     this.delayValue = value;
    // }
    updateSelectedDate(value) {
        this.dateSelected = value;
    }

    labelVariableSelector(option) {
        let description = option.description == null ? ' ' : option.description;
        return `${option.variable_id} - ${description}`;
    }

    get formIsValid() {
        if (this.dateSelected == null) {
            this.errorMsg = 'Debe asignar una fecha';
            return false;
        }
        if (this.workWidthValue == null) {
            this.errorMsg = 'Falta ingresar el Ancho de trabajo';
            return false;
        }

        if (!this.isEncased) {
            if (this.variableSelected == null) {
                this.errorMsg = 'No fue seleccionada ninguna variable';
                return false;
            }
        }
        this.errorMsg = '';
        return true;
    }

    @Emit()
    closeModal() {}

    @Emit()
    addNewSetting(item) {
        return item;
    }

    @Emit()
    patchSetting(item) {
        return item;
    }

    mounted() {
        // this.updateDelayValue(0);
        this.loadPatchData();
    }

    get isPatch() {
        return this.patchData !== null ? true : false;
    }

    loadPatchData() {
        this.setModalTitle();
        if (this.isPatch && this.patchData !== null) {
            this.updateSelectedDate(this.patchData['configuration_date']);
            this.encased = this.patchData['encased'];
            this.hasRTK = this.patchData['has_rtk'];
            this.updateVariableSelected(this.patchData['work_variable']);
            this.updateWorkWidthValue(this.patchData['work_width']);
            this.loadBlacklistedVars(this.patchData['blacklisted_variables'])
        }else{
            if(this.isSowing){
                //solo en creacion de sembradora
                this.encased = true;
            }
        }
    }

    setModalTitle() {
        this.modalTitle = this.isPatch && this.patchData !== null ? 'Modificar ' : 'Agregar ';
        this.modalTitle += 'Configuración ';
        if (this.isSowing !== null) {
            if (this.isSowing) {
                this.modalTitle += 'de Siembra';
            } else {
                this.modalTitle += 'de Cosecha';
            }
        }
    }
}
